import { env } from "@/lib/env"

// Runtime-injected release version. Keeping this out of next.config.js avoids
// rebuilding the full Next.js output when only SOURCE_VERSION changes.
export const RELEASE_VERSION = env("NEXT_PUBLIC_RELEASE_VERSION")
